import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

window.onerror = (msg, src, line, col, err) => {
  document.body.style.background = '#0f172a';
  document.body.style.color = '#f87171';
  document.body.style.fontFamily = 'monospace';
  document.body.style.padding = '20px';
  document.body.innerHTML = '<pre style="white-space:pre-wrap;word-break:break-all">ERROR:\n' + msg + '\n' + src + ':' + line + '\n' + (err && err.stack ? err.stack : '') + '</pre>';
};
window.onunhandledrejection = (e) => {
  document.body.style.background = '#0f172a';
  document.body.style.color = '#f87171';
  document.body.style.fontFamily = 'monospace';
  document.body.style.padding = '20px';
  document.body.innerHTML = '<pre style="white-space:pre-wrap;word-break:break-all">UNHANDLED REJECTION:\n' + (e.reason && e.reason.stack ? e.reason.stack : String(e.reason)) + '</pre>';
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);

// Register service worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      const stale = regs.filter((r) => {
        const sw = r.active || r.installing || r.waiting;
        return sw && sw.scriptURL && !sw.scriptURL.includes('/service-worker.js');
      });
      Promise.all(stale.map((r) => r.unregister())).then(() => {
        navigator.serviceWorker.register('/service-worker.js').catch((err) => {
          console.error('SW registration failed:', err);
        });
      });
    });
  });
}
